import { render, staticRenderFns } from "./Tasks.vue?vue&type=template&id=125136b7"
import script from "./Tasks.vue?vue&type=script&lang=js"
export * from "./Tasks.vue?vue&type=script&lang=js"
import style0 from "./Tasks.vue?vue&type=style&index=0&id=125136b7&prod&lang=scss"
import style1 from "./Tasks.vue?vue&type=style&index=1&id=125136b7&prod&lang=scss"
import style2 from "./Tasks.vue?vue&type=style&index=2&id=125136b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports